module.exports = __webpack_public_path__ + "static/media/Check.0a266767.svg";